export default __webpack_public_path__ + "static/media/ace_of_hearts.5a72df7d.png";